import { makeStyle } from '../../../../utils';
import { subTitle2, blackHigh, blackOutline, blackMedium } from '../../../../resources/styles';
import view from '../../../../Enums';

const styles = {};

styles['container'] = makeStyle({
    display: 'flex',
    alignItems: 'center',
    padding: 16,
});

styles['person'] = makeStyle({
    backgroundColor: blackOutline.color,
    color: 'white',
    borderRadius: 24,
    fontSize: 20,
    padding: 4,
});

styles['name'] = makeStyle({
    ...subTitle2,
    ...blackHigh,
    marginLeft: 8,
}, null, null, { display: 'none' });

styles['arrow'] = makeStyle(blackMedium, null, null, { display: 'none' });

styles['popper'] = makeStyle({ zIndex: 1000 , marginRight: 12 });

styles['account_details'] = makeStyle({
    backgroundColor: 'white',
    borderRadius: 6,
    boxShadow: 'var(--shadow)',
    overflow: 'hidden',
});

export default styles;